import { is } from '../is.js';

const alignsMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

/**
 * @typedef {Object} Bullets
 * @property {number} total
 * @property {string} align
 */

/**
 *
 * @param schema
 * @return {RawCreativeSchema & Bullets}
 */
export function addBullets(schema) {
  if (schema.bulletsAlign === null) {
    return schema;
  }

  const bulletsSlides = schema.slides.filter(is.slideDisplayMode.fullscreen);

  if (bulletsSlides.length < 2) {
    return schema;
  }

  bulletsSlides.forEach((slide, index) => {
    const bulletsContainer = {
      type: 'div',
      id: `bullets-${index}`,
      className: 'bullet-container',
      get parent() {
        return slide;
      },
      children: bulletsSlides.map((slide, bulletIndex) => {
        const bullet = {
          type: 'div',
          id: `bullet-${index}-${bulletIndex}`,
          className: 'bullet' + (bulletIndex === index ? ' active' : ''),
          get parent() {
            return schema.widgets[`bullets-${index}`];
          },
          children: [],
        };
        schema.widgets[bullet.id] = bullet;
        return schema.widgets[bullet.id];
      }),
    };

    schema.widgets[bulletsContainer.id] = bulletsContainer;
    slide.children.push(schema.widgets[bulletsContainer.id]);
  });

  schema.style ??= [];

  schema.style.push(
    [
      `.bullet-container`,
      [
        ['position', 'absolute'],
        ['width', '100%'],
        ['bottom', '12px'],
        ['display', 'flex'],
        ['padding', '0 20px'],
        ['flex-wrap', 'nowrap'],
        ['justify-content', alignsMap[schema.bulletsAlign]],
        ['box-sizing', 'border-box'],
      ],
    ],
    [
      `.bullet`,
      [
        ['min-width', '6px'],
        ['min-height', '6px'],
        ['margin', '4px 4px 0'],
        ['border-radius', '50%'],
        ['background-color', '#fff'],
        ['opacity', '0.3'],
      ],
    ],
    [
      `.bullet`,
      [
        ['max-width', '5px'],
        ['max-height', '5px'],
      ],
      '@media (min-width: 940px)',
    ],
    [`.bullet.active`, [['opacity', '1']]],
  );
  schema.bullets = {
    total: schema.bulletsAlign === null ? 0 : bulletsSlides.length,
    align: schema.bulletsAlign,
  };

  delete schema.bulletsAlign;

  return schema;
}
